import { Author } from '../../services/unified'
import UserAvatar from '../User/UserAvatar'
import { FunctionalComponent } from 'preact'
import { common } from '../common'

export interface PostMetaContainerProps {
  author: Author
  timestamp: string | number
}

export const PostMetaContainer: FunctionalComponent<PostMetaContainerProps> = (
  props
) => {
  const { timestamp, author, children } = props
  const relativeTime = common.relativeDate(timestamp)
  return (
    <div className='post-meta__container'>
      <div className='post-meta__container--left'>
        <UserAvatar user={author} extraClass='avatar avatar--XS' />
        <span className='thread-meta-item__date'>{relativeTime}</span>
      </div>
      {children && (
        <div className='post-meta__container--right'>{children}</div>
      )}
    </div>
  )
}
